/**
 * Whether a workspace shows the Memory entry in the left menu, read from its domain registry.
 *
 * **Opt-out, like Skills and unlike Quality or Developer.** Those two are subsystems a workspace
 * switches on, so they test `enabled === true`. Memory is a menu row that exists for everyone: an
 * absent row, a still-loading query and a workspace nobody has configured all mean "show it", and only
 * an explicit `false` hides it. Copying the `=== true` shape would make the row vanish for every
 * workspace until an owner went and enabled it.
 *
 * Its own module because two surfaces answer the same question — the sidebar, to decide whether to
 * render the row, and the route guard, to decide whether a deep link resolves — and a duplicated
 * predicate is how the two drift apart.
 */
export function memoryNavVisible(
  domains: readonly { domain: string; enabled: boolean }[] | undefined,
): boolean {
  return (
    domains?.find((domain) => domain.domain === 'memory')?.enabled !== false
  );
}
